import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './app/App.vue';
import { router } from './app/router';
import './styles/theme.css';
import './styles/legacy-parity.css';
import './styles/result-fade.css';
// 1.1.68: 列表页统一观感（挂在 <ResourcePage class="list-page"> 上生效）
import './styles/list-page.css';
// 1.1.84: 开发模式（devmode）—— 板块复制图标、提示气泡与顶栏开关按钮样式
import './styles/devmode.css';

createApp(App).use(createPinia()).use(router).mount('#app');
